class TabsElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabButtons = this.querySelectorAll('[role="tab"]');
    this.tabButtons.forEach((tab) => {
      tab.addEventListener("click", this.onTabClick.bind(this));
    });
  }

  onTabClick(e) {
    if (e.target.getAttribute("aria-selected") == "true") return;
    const targetPanelId = e.target.getAttribute("aria-controls");
    if (!targetPanelId) return;
    const targetPanel = this.querySelector(`[role="tabpanel"][id=${targetPanelId}]`);
    if (!targetPanel) return;
    this.setActiveTab(e.target);
    this.setActivePanel(targetPanel);
  }

  setActiveTab(targetTab) {
    const activeTab = this.querySelector('[role="tab"][aria-selected="true"]');
    activeTab.setAttribute("aria-selected", "false");
    targetTab.setAttribute("aria-selected", "true");
  }

  setActivePanel(targetPanel) {
    const activePanel = this.querySelector('[role="tabpanel"][data-active]');
    activePanel.removeAttribute("data-active");
    this.tabButtons.forEach((button) => {
      button.disabled = true;
    });
    activePanel.addEventListener(
      "transitionend",
      () => {
        activePanel.style.display = "none";
        targetPanel.style.display = "block";
        setTimeout(() => targetPanel.setAttribute("data-active", ""));
        this.tabButtons.forEach((button) => {
          button.disabled = false;
        });
      },
      { once: true }
    );
  }
}

customElements.define("tabs-element", TabsElement);
